import { createDefaultRecipientRoleFieldBase } from './default-recipient-role-field'
import { FieldEnum, FieldTypeEnum, SelectedFieldEnum } from './fields.dto'

export const Signaturefield = {
    tag(field){
        return {
            ...createDefaultRecipientRoleFieldBase(field),
            field_name: "Signature Field",
            field: FieldEnum.SignatureField,
            type: FieldTypeEnum.Signature,
            selected_field: SelectedFieldEnum.SignatureField,
            field_required: field.field_required ?? "1",
            pre_checked: field.pre_checked ?? "0"
        }
    }
}